import React from 'react';
import classNames from 'classnames';
import { Button } from '../../shared';
import { ReactComponent as BeeFly } from '../../images/BeeFly.svg';
import styles from '../Main.module.scss';
import { BEEHERO_IO_URL } from '../../shared/consts';
import { beeheroIo, thankYou, toTheDemo, willContactYouSoon } from './textConsts';
import PropTypes from 'prop-types';
import useMediaQuery from '../../shared/hooks/useMediaQuery';
import { isMobileQuery } from '../../shared/MediaQuery/mediaQueryUtils';

const ContactUsSuccess = ({ goToDemo }) => {
    const isMobile = useMediaQuery(isMobileQuery);
    return (
        <div className={styles.contactus_success}>
            <BeeFly className={styles.bee_fly} />
            <div className={classNames(styles.title, { [styles.lg]: isMobile })}>{thankYou}</div>
            <div className={styles.message}>{willContactYouSoon}</div>

            <div className={styles.buttons_container}>
                <Button color="yellow" onClick={() => (window.location.href = BEEHERO_IO_URL)} noUppercase>
                    {beeheroIo}
                </Button>
                {!isMobile && (
                    <Button color="white-outlined" onClick={goToDemo} noUppercase>
                        {toTheDemo}
                    </Button>
                )}
            </div>
        </div>
    );
};

ContactUsSuccess.propTypes = {
    goToDemo: PropTypes.func
};

export default ContactUsSuccess;
